import * as React from 'react';
import { SelectBox, SelectBoxOption } from 'sos-common/js/components/FormControls/SelectBox';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import { SectionClass, SectionState, SectionProps, FieldName } from '../PublicForm.types';

export interface IYrkeSectionProps extends SectionProps {
  yrken: SelectBoxOption[];
  onChangeYrke: (yrke: string, callback: () => void) => void;
}

export interface IYrkeSectionState extends SectionState {}

const RequiredFieldListyrke = [FieldName.Yrke];

export default class YrkeSection extends SectionClass<IYrkeSectionProps, IYrkeSectionState> {
  constructor(props: IYrkeSectionProps) {
    super(props);

    this.state = {
      errors: this.getInitialErrorMap(RequiredFieldListyrke),
    };
  }

  onYrkeChange = (field: FormField<any>) => {
    this.onChangeField(field);

    this.props.onChangeYrke(field.value, this.afterYrkeChanged);
  };

  afterYrkeChanged = () => {
    this.props.onChangeFieldValue();
  };

  public render() {
    const { yrken, Translate } = this.props;
    return (
      <section>
        <SelectBox
          onChange={this.onYrkeChange}
          label={Translate('valjyrke')}
          className="max25"
          defaultOptionText={Translate('valj')}
          fieldName={FieldName.Yrke}
          options={yrken}
          errorMessage={this.getErrorMessage(FieldName.Yrke)}
          isRequired={true}
        />
        <hr className="formdivider" />
      </section>
    );
  }
}
